import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { GetService } from 'src/app/dataservices/get.service';
import { OnboardingService } from 'src/app/dataservices/onboarding/onboarding.service';

/**
 * constant imports
 */
import { CountryList } from 'src/app/onboarding/interface/global.model';
@Component({
  selector: 'app-phone-number',
  templateUrl: './phone-number.component.html',
  styleUrls: ['./phone-number.component.scss']
})


export class PhoneNumberComponent implements OnInit {

  @Input() label: string;
  @Input() formControlName: string;
  @Input() phoneNumber = '';

  @Input() mandatory=false;


  /**
   * Used to emit the selected value.
   */
  @Output() emitSelectedValue: EventEmitter<string> = new EventEmitter();

  /**
   * emit focuse out on input tag
   */
  @Output() emitTouched: EventEmitter<void> = new EventEmitter();

  /**
   * country code
   */
  countryCode: number;

  /**
   * mobile number
   */
  mobileNumber: string;
  
  /**
   * suggestion list for country codes
   */
  suggestionList: CountryList[];

  /**
   * image base url
   */
  public imageBaseUrl: string;
  

  public isNumberValid = true;

  public form: FormGroup;

  @Input() isInErrorState: boolean;

  /**
   * for api subscription
   */
  private subscriptions: Subscription = new Subscription();

    constructor(public getService: GetService,public onboardingService: OnboardingService, public chg: ChangeDetectorRef, public formBuilder: FormBuilder ) {

    }
  
  ngOnInit(): void {
    const index = this.phoneNumber.indexOf('-');
    if (index !== -1) {
      this.countryCode =parseInt(this.phoneNumber.substring(0, index));
      if (!this.countryCode) {
        this.countryCode = 91;
      } 
      this.mobileNumber = this.phoneNumber.substring(index+1, this.phoneNumber.length);
    }
    this.form =  this.formBuilder.group({
      code: new FormControl(this.countryCode),
      mobileNumber: new FormControl(this.mobileNumber),
    });
    this.getCountryList();
  }

  elementTouced(): void {
    this.emitTouched.emit();
  }
  selectedValues(event): void {
  }
  onCompleteMethod(event): void {
    this.suggestionList = [...this.suggestionList];
  }
  inputValid(): boolean{
    if (this.countryCode == 62) {
      if (this.mobileNumber?.length > 5) {
        this.mobileNumber = this.mobileNumber.substr(0, 12);
      }
      else {
        this.emitSelectedValue.emit('');
        return false;
      }
    } else if (this.countryCode == 63) {
      if (this.mobileNumber?.length > 5) {
        this.mobileNumber = this.mobileNumber.substr(0, 11);
      }
      else {
        this.emitSelectedValue.emit('');
        return false;
      }
    } else if (this.countryCode == 66) {

      if (this.mobileNumber?.length > 8) {
        this.mobileNumber = this.mobileNumber.substr(0, 10);
      } 
      else {
        this.emitSelectedValue.emit('');
        return false;
      }
    } else if (this.countryCode == 60) {
      if (this.mobileNumber?.length > 8) {
        this.mobileNumber = this.mobileNumber.substr(0, 10);
      }
      else {
        this.emitSelectedValue.emit('');
        return false;
      }
    } else {
      if (this.mobileNumber?.length > 3) {
        this.mobileNumber = this.mobileNumber.substr(0, 15);
      }
      else {
        this.emitSelectedValue.emit('');
        return false;
      }
    }
    this.emitData();
    return true;
  }
  countryCodeSelect(event): void {
    this.emitData();
  }
  emitData(): void {
    let phoneNumber = this.countryCode;
    if (this.mobileNumber) {
      this.emitSelectedValue.emit(phoneNumber + '-' + this.mobileNumber);
    }
  }
  getCountryList(): any {
    this.subscriptions.add(this.onboardingService.getCountryList().subscribe(resData => {
      this.suggestionList = resData.data.country_list;
      this.imageBaseUrl = resData.data.image_base_path;
      this.chg.detectChanges();
      this.chg.markForCheck();
    }));
 }

}
